import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { I18nProvider } from 'react-aria-components';
import { createRoot } from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import './i18n';
import { createAppRouter } from './router';
import './styles.css';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1 } } });
const router = createAppRouter(queryClient);

/** The texts that React Aria itself says (for assistive technology) follow the language chosen in the app. */
function App() {
  const { i18n } = useTranslation();
  return (
    <I18nProvider locale={i18n.language}>
      <RouterProvider router={router} />
    </I18nProvider>
  );
}

const root = document.getElementById('root');
if (!root) throw new Error('Falta el elemento #root');
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
